// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at top left, rgba(245, 162, 93, 0.28) 0%, rgba(245, 162, 93, 0) 28%), radial-gradient(circle at 88% 14%, rgba(72, 136, 222, 0.18) 0%, rgba(72, 136, 222, 0) 24%), linear-gradient(180deg, #fff7ec 0%, #f6f3ef 38%, #e7edf4 100%);
  padding: 24px 18px 48px;
  box-sizing: border-box;
}

.contact-us-shell {
  position: relative;
  z-index: 1;
  max-width: 1180px;
  margin: 0 auto;
}

.contact-us-top-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 18px;
}

.contact-us-top-button {
  border: 0;
  border-radius: 999px;
  padding: 12px 16px;
  cursor: pointer;
  background: linear-gradient(135deg, #193e6d 0%, #2c73c6 100%);
  color: #fff9f0;
  font: 700 0.9rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  box-shadow: 0 12px 28px rgba(22, 53, 92, 0.18);
}

.contact-us-top-button-secondary {
  background: rgba(255, 255, 255, 0.78);
  color: #163355;
}

.contact-us-hero,
.contact-us-content,
.contact-us-card {
  position: relative;
  overflow: hidden;
  border-radius: 34px;
  box-shadow: 0 28px 58px rgba(18, 31, 51, 0.15);
}

.contact-us-hero {
  margin-bottom: 22px;
  padding: 30px 26px;
  color: #fffaf2;
  background: radial-gradient(circle at top right, rgba(253, 209, 151, 0.22) 0%, rgba(253, 209, 151, 0) 30%), linear-gradient(145deg, rgba(13, 24, 41, 0.98) 0%, rgba(24, 54, 90, 0.95) 58%, rgba(182, 93, 38, 0.86) 100%);
}

.contact-us-kicker {
  display: inline-flex;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #ffe7c9;
  font: 700 0.76rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.contact-us-hero h1 {
  margin: 0 0 14px;
  font: 800 clamp(2.4rem, 6vw, 4.2rem)/0.96 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: -0.06em;
}

.contact-us-hero p {
  max-width: 860px;
  margin: 0 0 12px;
  color: rgba(255, 250, 242, 0.86);
  font: 500 1rem/1.7 "Trebuchet MS", "Gill Sans", sans-serif;
}

.contact-us-hero p:last-child {
  margin-bottom: 0;
}

.contact-us-layout {
  display: grid;
  gap: 22px;
}

.contact-us-content {
  display: grid;
  gap: 18px;
  padding: 28px 24px;
  background: rgba(255, 255, 255, 0.84);
  backdrop-filter: blur(12px);
}

.contact-us-content h2,
.contact-us-title {
  margin: 0;
  color: #19314f;
  font: 800 1.5rem/1.2 "Trebuchet MS", "Gill Sans", sans-serif;
}

.contact-us-details {
  display: grid;
  gap: 16px;
}

.contact-us-details h3 {
  margin: 0 0 6px;
  color: #17314f;
  font: 700 1rem/1.3 "Trebuchet MS", "Gill Sans", sans-serif;
}

.contact-us-details p,
.contact-us-summary,
.contact-us-reasons li {
  margin: 0;
  color: #19314f;
  font: 500 1rem/1.75 "Trebuchet MS", "Gill Sans", sans-serif;
}

.contact-us-details a {
  color: #1f5ea8;
}

.contact-us-reasons {
  display: grid;
  gap: 10px;
  margin: 0;
  padding-left: 22px;
}

.contact-us-card {
  width: 100%;
  padding: 28px;
  background-color: #ffffff;
}

.contact-us-hint {
  margin: 10px 0 16px;
  color: #526175;
  font-size: 0.95rem;
}

.contact-us-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}

.contact-us-field label {
  margin-bottom: 6px;
  color: #2e3a4b;
  font-weight: 600;
}

.contact-us-field input,
.contact-us-field textarea {
  border: 1px solid #c8d2e1;
  border-radius: 8px;
  font-size: 1rem;
  padding: 10px 12px;
  outline: none;
  transition: border-color 0.2s ease;
  font-family: inherit;
}

.contact-us-field input:focus,
.contact-us-field textarea:focus {
  border-color: #2b7fff;
}

.contact-us-field textarea {
  resize: vertical;
}

.contact-us-submit {
  width: 100%;
  border: none;
  border-radius: 8px;
  margin-top: 8px;
  padding: 11px 12px;
  background-color: #2353b8;
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 700;
  cursor: pointer;
}

.contact-us-submit:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.contact-us-message {
  margin-top: 12px;
  font-size: 0.92rem;
}

.contact-us-message.success {
  color: #0f8a42;
}

.contact-us-message.error {
  color: #b52828;
}

.contact-us-glow {
  position: absolute;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  filter: blur(22px);
  opacity: 0.4;
}

.contact-us-glow-left {
  left: -80px;
  top: 40px;
  background: rgba(242, 166, 105, 0.5);
}

.contact-us-glow-right {
  right: -90px;
  bottom: 60px;
  background: rgba(62, 146, 196, 0.34);
}

@media (min-width: 900px) {
  .contact-us-layout {
    grid-template-columns: minmax(0, 1.15fr) minmax(360px, 0.85fr);
    align-items: start;
  }
}
@media (min-width: 768px) {
  .contact-us-page {
    padding: 38px 24px 56px;
  }
  .contact-us-hero {
    padding: 38px 34px;
  }
  .contact-us-content,
  .contact-us-card {
    padding: 34px 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/contact-us/ContactUsPage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mQACE;EAGF,uBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;EACE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,6DAAA;EACA,cAAA;EACA,0DAAA;EACA,8CAAA;AAFF;;AAKA;EACE,qCAAA;EACA,cAAA;AAFF;;AAKA;;;EAGE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8CAAA;AAFF;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,wNACE;AAHJ;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qCAAA;EACA,cAAA;EACA,2DAAA;EACA,sBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,iFAAA;EACA,uBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0DAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;AAJF;;AAOA;;EAEE,SAAA;EACA,cAAA;EACA,4DAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,0DAAA;AAJF;;AAOA;;;EAGE,SAAA;EACA,cAAA;EACA,2DAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;AAJF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;;EAEE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;AAJF;;AAOA;;EAEE,qBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAJF;;AAOA;EACE,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,gBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,SAAA;EACA,oCAAA;AAJF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,oCAAA;AAJF;;AAOA;EACE;IACE,8DAAA;IACA,kBAAA;EAJF;AACF;AAOA;EACE;IACE,uBAAA;EALF;EAQA;IACE,kBAAA;EANF;EASA;;IAEE,kBAAA;EAPF;AACF","sourcesContent":[".contact-us-page {\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at top left, rgba(245, 162, 93, 0.28) 0%, rgba(245, 162, 93, 0) 28%),\n    radial-gradient(circle at 88% 14%, rgba(72, 136, 222, 0.18) 0%, rgba(72, 136, 222, 0) 24%),\n    linear-gradient(180deg, #fff7ec 0%, #f6f3ef 38%, #e7edf4 100%);\n  padding: 24px 18px 48px;\n  box-sizing: border-box;\n}\n\n.contact-us-shell {\n  position: relative;\n  z-index: 1;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.contact-us-top-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.contact-us-top-button {\n  border: 0;\n  border-radius: 999px;\n  padding: 12px 16px;\n  cursor: pointer;\n  background: linear-gradient(135deg, #193e6d 0%, #2c73c6 100%);\n  color: #fff9f0;\n  font: 700 0.9rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  box-shadow: 0 12px 28px rgba(22, 53, 92, 0.18);\n}\n\n.contact-us-top-button-secondary {\n  background: rgba(255, 255, 255, 0.78);\n  color: #163355;\n}\n\n.contact-us-hero,\n.contact-us-content,\n.contact-us-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: 34px;\n  box-shadow: 0 28px 58px rgba(18, 31, 51, 0.15);\n}\n\n.contact-us-hero {\n  margin-bottom: 22px;\n  padding: 30px 26px;\n  color: #fffaf2;\n  background:\n    radial-gradient(circle at top right, rgba(253, 209, 151, 0.22) 0%, rgba(253, 209, 151, 0) 30%),\n    linear-gradient(145deg, rgba(13, 24, 41, 0.98) 0%, rgba(24, 54, 90, 0.95) 58%, rgba(182, 93, 38, 0.86) 100%);\n}\n\n.contact-us-kicker {\n  display: inline-flex;\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffe7c9;\n  font: 700 0.76rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.contact-us-hero h1 {\n  margin: 0 0 14px;\n  font: 800 clamp(2.4rem, 6vw, 4.2rem)/0.96 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: -0.06em;\n}\n\n.contact-us-hero p {\n  max-width: 860px;\n  margin: 0 0 12px;\n  color: rgba(255, 250, 242, 0.86);\n  font: 500 1rem/1.7 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.contact-us-hero p:last-child {\n  margin-bottom: 0;\n}\n\n.contact-us-layout {\n  display: grid;\n  gap: 22px;\n}\n\n.contact-us-content {\n  display: grid;\n  gap: 18px;\n  padding: 28px 24px;\n  background: rgba(255, 255, 255, 0.84);\n  backdrop-filter: blur(12px);\n}\n\n.contact-us-content h2,\n.contact-us-title {\n  margin: 0;\n  color: #19314f;\n  font: 800 1.5rem/1.2 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.contact-us-details {\n  display: grid;\n  gap: 16px;\n}\n\n.contact-us-details h3 {\n  margin: 0 0 6px;\n  color: #17314f;\n  font: 700 1rem/1.3 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.contact-us-details p,\n.contact-us-summary,\n.contact-us-reasons li {\n  margin: 0;\n  color: #19314f;\n  font: 500 1rem/1.75 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.contact-us-details a {\n  color: #1f5ea8;\n}\n\n.contact-us-reasons {\n  display: grid;\n  gap: 10px;\n  margin: 0;\n  padding-left: 22px;\n}\n\n.contact-us-card {\n  width: 100%;\n  padding: 28px;\n  background-color: #ffffff;\n}\n\n.contact-us-hint {\n  margin: 10px 0 16px;\n  color: #526175;\n  font-size: 0.95rem;\n}\n\n.contact-us-field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 14px;\n}\n\n.contact-us-field label {\n  margin-bottom: 6px;\n  color: #2e3a4b;\n  font-weight: 600;\n}\n\n.contact-us-field input,\n.contact-us-field textarea {\n  border: 1px solid #c8d2e1;\n  border-radius: 8px;\n  font-size: 1rem;\n  padding: 10px 12px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  font-family: inherit;\n}\n\n.contact-us-field input:focus,\n.contact-us-field textarea:focus {\n  border-color: #2b7fff;\n}\n\n.contact-us-field textarea {\n  resize: vertical;\n}\n\n.contact-us-submit {\n  width: 100%;\n  border: none;\n  border-radius: 8px;\n  margin-top: 8px;\n  padding: 11px 12px;\n  background-color: #2353b8;\n  color: #ffffff;\n  font-size: 0.98rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.contact-us-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.contact-us-message {\n  margin-top: 12px;\n  font-size: 0.92rem;\n}\n\n.contact-us-message.success {\n  color: #0f8a42;\n}\n\n.contact-us-message.error {\n  color: #b52828;\n}\n\n.contact-us-glow {\n  position: absolute;\n  width: 240px;\n  height: 240px;\n  border-radius: 50%;\n  filter: blur(22px);\n  opacity: 0.4;\n}\n\n.contact-us-glow-left {\n  left: -80px;\n  top: 40px;\n  background: rgba(242, 166, 105, 0.5);\n}\n\n.contact-us-glow-right {\n  right: -90px;\n  bottom: 60px;\n  background: rgba(62, 146, 196, 0.34);\n}\n\n@media (min-width: 900px) {\n  .contact-us-layout {\n    grid-template-columns: minmax(0, 1.15fr) minmax(360px, 0.85fr);\n    align-items: start;\n  }\n}\n\n@media (min-width: 768px) {\n  .contact-us-page {\n    padding: 38px 24px 56px;\n  }\n\n  .contact-us-hero {\n    padding: 38px 34px;\n  }\n\n  .contact-us-content,\n  .contact-us-card {\n    padding: 34px 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
